import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, getPaletteColor } from 'pcln-design-system'

const AffirmFooterBox = styled(Box)`
  display: none;
  ${(props) => props.theme.mediaQueries.md} {
    display: inline;
  }

  ${(props) => props.theme.mediaQueries.xl} {
    ${(props) => props.isUpsellTray && 'display: none;'}
  }
  border-left: solid ${getPaletteColor('border.base')} 1px;
`

const AffirmFooterMessage = ({ affirmNode, isUpsellTray }) =>
  affirmNode ? (
    <AffirmFooterBox
      ml='auto'
      width='28%'
      py={2}
      isUpsellTray={isUpsellTray}
      data-testid='itinerary-affirm-messaging'
    >
      {affirmNode}
    </AffirmFooterBox>
  ) : null

AffirmFooterMessage.propTypes = {
  /** Node that contains Affirm Text */
  affirmNode: PropTypes.node,
  isUpsellTray: PropTypes.bool,
}

export { AffirmFooterMessage }
